<template>
  <div>
    <span v-if="item.startDate">{{item.startDate | formatDate}}</span><span v-if="!item.startDate">Started</span> -> 
    <span v-if="item.expiryDate">{{item.expiryDate | formatDate}}</span><span v-if="!item.expiryDate">Never Expires</span>
  </div>
</template>
<script>
export default {
  name: 'startsexpires',
  props: ['item']
}
</script>
